const locale = {
	// #region Work Reports fields
	DETAILS_WORKREPORTS_FIELD_TITLE: 'Title',
	DETAILS_WORKREPORTS_FIELD_STATUS: 'Work Report Status',
	DETAILS_WORKREPORTS_FIELD_TYPE: 'Work Report Type',
	DETAILS_WORKREPORTS_FIELD_COMPANY: 'Company',
	DETAILS_WORKREPORTS_FIELD_ASSIGNED_USER: 'Assigned User',
	DETAILS_WORKREPORTS_FIELD_DATE: 'Date',
	DETAILS_WORKREPORTS_FIELD_HOUR_FROM: 'Start time',
	DETAILS_WORKREPORTS_FIELD_HOUR_TO: 'End time',
	DETAILS_WORKREPORTS_FIELD_LENGTH_HOURS: 'Total hours',
	DETAILS_WORKREPORTS_FIELD_LENGTH_MINUTES: 'Total minutes',
	DETAILS_WORKREPORTS_FIELD_TAGS: 'Tags',
	DETAILS_WORKREPORTS_FIELD_WARNING: 'Warning',
	DETAILS_WORKREPORTS_FIELD_BLOCKED: 'Blocked',
	DETAILS_WORKREPORTS_FIELD_EXPENSES: 'Expenses',
	DETAILS_WORKREPORTS_FIELD_KM: 'Travelled distance',
	DETAILS_WORKREPORTS_FIELD_LENGTH_HOURS_EXPECTED: 'Total expected hours',
	DETAILS_WORKREPORTS_FIELD_LENGTH_MINUTES_EXPECTED: 'Total expected minutes',
	// DETAILS_WORKREPORTS_FIELD_PEOP: 'External Contact',
	DETAILS_WORKREPORTS_FIELD_CREATED_BY: 'Created by' // ORDER_BY
	// #endregion
};

export default locale;
